module.exports = __webpack_public_path__ + "static/media/process.22985332.gif";